import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RitwikReportService } from '../../../../services/raintree/Transmission/ritwik-report.service';
import { ToastrService } from 'ngx-toastr';
import { log } from 'console';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../../../../services/common/search.service';
import { MatDialog } from '@angular/material/dialog';
import { RitwikCustomDateComponent } from './ritwik-custom-date/ritwik-custom-date.component';

@Component({
  selector: 'app-ritwik-report',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './ritwik-report.component.html',
  styleUrl: './ritwik-report.component.scss'
})
export class RitwikReportComponent implements OnInit {
  searchFc = new FormControl('')
  searchReq = new FormControl('')
  reportDetails: any[] = [];
  dateDetails: any[] = []
  filterData: any[] = []
  terms: string | null = null;
  date: string = ''
  isFY: boolean = false
  isActive: boolean = false
  count: Record<string, number> = {}
  tempData: any = [];
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  isMobile: boolean = false;
  // firstQtr: string = '2025-04-01 - 2025-06-30'
  quater: any[] = [
    {
      '1st': {
        startDate: 4,
        endDate: 6
      },
      '2nd': {
        startDate: 7,
        endDate: 9
      },
      '3rd': {
        startDate: 10,
        endDate: 12
      },
      '4th': {
        startDate: 1,
        endDate: 3
      }
    }
  ]

  displayColumn = [
    {
      id: 'dpTotal'
    },
    {
      id: 'offlineTotal'
    },
    {
      id: 'onlineTotal'
    },
    {
      id: 'spTotal'
    },
    {
      id: 'submitDate'
    }
  ]

  constructor(
    private reportService: RitwikReportService,
    private toaster: ToastrService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _searchService: SearchService,
    private _dialog: MatDialog


  ) { }

  ngOnInit(): void {
    this.isMobile = window.matchMedia("(max-width: 600px)").matches
    console.log(this.isMobile);


    this.subscribeToParams()
    this.searchFc.valueChanges.subscribe((value) => {
      this.reportDetails = [];
      if (value?.length === 12)
        this.getReportDetails(false)
    });
    this.searchReq.valueChanges.subscribe((value: any) => {
      this.dateDetails = this.tempData
      if (value?.length > 0) this.onSearch(value);

    });
  }

  getTerms(type: string) {
    this.terms = this.terms === type ? null : type
    console.log(this.terms);

    this.isFY = true

    if (this.terms !== null && this.terms !== 'custom') {
      this.isActive = true
      const qtr = this.quater.find(item => type in item)?.[type]
      this.filterData = this.tempData = this.dateDetails.filter(val => {
        const itemMonth = new Date(val.submitDate).getMonth() + 1;
        return itemMonth >= qtr?.startDate &&
          itemMonth <= qtr?.endDate;
      });

    } else if (this.terms === 'custom') {
      this.isActive = true
      const dialogRef = this._dialog.open(RitwikCustomDateComponent)
      dialogRef.afterClosed().subscribe({
        next: (res) => {
          if (!res) {
            this.terms = null
            this.getDateDetails()
          }

          if (res.result) {
            const result = res.result
            this.filterData = this.tempData = this.dateDetails.filter((val: any) => {
              const start = result?.startDate ? result?.startDate : null;
              const end = result?.endDate ? result?.endDate : null
              if (start && end) {
                return val.submitDate >= result?.startDate &&
                  val.submitDate <= result?.endDate
              }
              if (start && !end) {
                return val.submitDate >= result?.startDate
              }
              if (!start && end) {
                return val.submitDate <= result?.endDate
              }

              return true
            });
            console.log(this.filterData);


          }
        }
      })
    } else {
      this.getDateDetails()
    }

  }

  restrictFCInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[0-9]*$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 11) {
      event.preventDefault();
    }
  }

  getReportDetails(isStart: boolean) {
    if (!isStart) {
      const obj = {
        fc: this.searchFc?.value
      }
      this.reportService.getRitwikReport(obj).subscribe({
        next: (res) => {
          this.reportDetails = res.data
          this.isFY = false
          this.dateDetails = []
          // console.log(this.reportDetails);
        },
        error: (err) => {
          this.toaster.error(err);
        }
      })
    } else {
      this.reportDetails = this.reportDetails
    }
  }

  getDateDetails(item?: any) {
    if (item !== null && item !== undefined) {
      this.date = item
      this._router.navigate([`${this._router.url}`], {
        queryParams: {
          year: item,
        },
      });
    }
    this.isFY = true
    this.isActive = false
    const details = this.reportDetails.filter(val => val.period === this.date)
    this.dateDetails = this.tempData = details[0].details
  }

  subscribeToParams() {
    this._activatedRoute.queryParams.subscribe(params => {
      if (!params['year']) {
        this.getReportDetails(true)
        this.isFY = false
        this.dateDetails = []
        this.terms = ''
      }
    })
  }

  onSearch(value: any) {

    if (this.isFY && !this.isActive) {
      this.dateDetails = this._searchService.filterData(
        this.dateDetails,
        value,
        this.displayColumn
      )
      console.log(this.dateDetails);


    } else if (this.isFY && this.isActive) {
      this.filterData = this._searchService.filterData(
        this.filterData,
        value,
        this.displayColumn
      )
    }

  }

  clearInp() {
    this.searchFc.setValue('')
    this.reportDetails = []
    // this.isFY = false
  }


}
